import { render, staticRenderFns } from "./HrSalaryBonusTheory.vue?vue&type=template&id=5ec24ac5&scoped=true&"
import script from "./HrSalaryBonusTheory.vue?vue&type=script&lang=js&"
export * from "./HrSalaryBonusTheory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec24ac5",
  null
  
)

export default component.exports